import axios from 'axios';
import { hostname } from './util';

export const sendBroadcast = ({ id, ...params }) => {
  return axios.post(`${hostname}/comms/projects/${id}/broadcast`, params);
};

export default sendBroadcast;
